/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { defineComponent } from 'vue';

// @ts-ignore Není to ESM.
import template from './setup-settings.html';

import { $root } from '../../player/player';
import { mixinType } from '../../util.type';
import focus from '../focus/focus-directive';
import SetupHeader from './setup-header';

// TODO Univerzální komponenta `FormField`. Nyní se kód opakuje.
export default defineComponent({
  name: 'SetupSettings',
  template,
  components: { SetupHeader },
  created() {
    this.submitted = false;
  },
  directives: { focus },
  data() {
    return mixinType(
      {
        field: {
          serverUrl: {
            label: 'Ki-Wi Server URL address',
            validator: {
              required: true,
              url: { require_tld: false }
            },
            value: this.serverUrl
          }
        }
      },
      /**
       * @type {{
       *   submitted: boolean;
       * }}
       */
      ({})
    );
  },
  emits: {
    back() {},
    /**
     * @param {string} serverUrl
     */
    submit(serverUrl) {}
  },
  methods: {
    /**
     * @param {Error} error
     */
    handleError(error) {
      $root(this).logger.error(error);
    },
    onBack() {
      this.$emit('back');
    },
    onChange() {
      new Promise((resolve) => {
        if (!this.submitted) {
          return resolve(undefined);
        }
        return resolve(this.$validator.validateAll());
      }).catch((error) => this.handleError(error));
    },
    onReset() {
      this.field.serverUrl.value = this.defaultServerUrl;
    },
    onSubmit() {
      new Promise((resolve) => {
        this.submitted = true;
        return resolve(this.$validator.validateAll());
      })
        .then((valid) => {
          if (!valid) {
            return;
          }
          this.$emit('submit', this.field.serverUrl.value);
        })
        .catch((error) => this.handleError(error));
    }
  },
  props: {
    defaultServerUrl: { type: String, required: true },
    isOnline: { type: Boolean, required: true },
    serverUrl: { type: String, required: true }
  }
});
